import React from 'react';
import './preview-casino-badge.scss';

/** Small pill on casino cards unlocked via slotcheck-previewComingSoonCasinos. */
export const PreviewCasinoBadge: React.FC = () => (
  <span className="preview-casino-badge" data-testid="preview-casino-badge">
    Preview
  </span>
);

export default PreviewCasinoBadge;
